import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getEditionByTenantId } from "../service/tenantEdition/TenantEditionService";


export function useSubscriptionGuard() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const [isExpired, setIsExpired] = useState(false);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    async function checkSubscription() {
      const tenantIdStr = localStorage.getItem("tenantId");
      if (!tenantIdStr) return;

      const tenantId = Number(tenantIdStr);
      if (!tenantId) return;

      try {
        const res = await getEditionByTenantId(dispatch, tenantId);

        // 🟢 First-time login (no plan yet)
        if (!res?.endDate) {
          setChecked(true);
          return;
        }

        const expiryDate = new Date(res.endDate);
        const today = new Date();

        if (expiryDate < today) {
          setIsExpired(true);

          if (location.pathname !== "/subscription-plan") {
            navigate("/subscription-plan", { replace: true });
          }
        }

        setChecked(true);
      } catch (err) {
        console.error("Subscription check failed", err);
        setChecked(true);
      }
    }

    checkSubscription();
  }, [dispatch, navigate, location.pathname]);

  return { isExpired, checked };
}
